import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import WhyWamglammz from "./pages/WhyWamglammz";
import About from "./pages/About";
import Resource from "./pages/Resource";
import Features from "./pages/Features";
import Blog from "./pages/Blog";
import "./styles.css";
import ContactUs from "./components/ContactUs";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AboutShy from "./pages/AboutShy";
import VendorPlatform from "./pages/VendorPlatform";
import BookingPage from "./pages/BookingPage";
import BusinessAccess from "./pages/BusinessAccess";
import ScrollToTop from "./components/ScrollToTop";
function App() {
  return (

    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/why-wamglammz" element={<WhyWamglammz />} />
        <Route path="/about" element={<About />} />
        <Route path="/resource" element={<Resource />} />
        <Route path="/features" element={<Features />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/about-shy" element={<AboutShy />} />
        <Route path="/for-business" element={<BusinessAccess initialMode="login" />} />
        <Route path="/for-business/login" element={<BusinessAccess initialMode="login" />} />
        <Route path="/for-business/register" element={<BusinessAccess initialMode="register" />} />
        <Route path="/for-business/dashboard" element={<VendorPlatform />} />
        <Route path="/vendor-platform" element={<Navigate to="/for-business/dashboard" replace />} />
        <Route path="/book/:vendorSlug" element={<BookingPage />} />
      </Routes>
    </Router>
  );
}

export default App;
